/**
 * Redondeo al peso (HALF_UP: ≥0.50 sube) y valor numérico en .00.
 * Misma regla que configurador.pricing.round_to_peso.
 * Run: npx tsx --test src/lib/roundToPeso.test.ts
 */

function toFinite(value: string | number | null | undefined): number {
  if (value === null || value === undefined) return 0;
  const n = typeof value === "number" ? value : parseFloat(String(value));
  return Number.isFinite(n) ? n : 0;
}

export function roundToPeso(value: string | number | null | undefined): number {
  const n = toFinite(value);
  if (!Number.isFinite(n)) return 0;
  const sign = n < 0 ? -1 : 1;
  const entero = Math.floor(Math.abs(n) + 0.5);
  return sign * entero;
}

export function lineImportePeso(opts: {
  precio: number;
  cantidad: number;
  descuento1?: number;
  descuento2?: number;
}): number {
  const p = roundToPeso(opts.precio);
  let sub = p * toFinite(opts.cantidad);
  const d1 = toFinite(opts.descuento1);
  const d2 = toFinite(opts.descuento2);
  if (d1 > 0) sub -= (sub * d1) / 100;
  if (d2 > 0) sub -= (sub * d2) / 100;
  return roundToPeso(sub);
}
